import { request } from 'utils/ajax';
import {
    BygrProject,
    PaginationResult,
    BygrProjectDetails,
    PaginatedSearchRequest,
    ProjectDashboardData,
    ProjectUnit,
    BygrModule,
    CreateSubProjectDto,
} from 'types';
import { toQueryString } from 'utils/url';
import { LandingPageImageDTO } from '@ygtechnologies/bygr-frontend-component-library';

export function getProjects(req: PaginatedSearchRequest): Promise<PaginationResult<BygrProject>> {
    return request(`api/project`, { query: req }).then((x) => x.json());
}
export function getProjectsExportUrl(req: PaginatedSearchRequest) {
    return `api/project/excel?${toQueryString(req)}`;
}
export function getProjectDetails(id: number): Promise<BygrProjectDetails> {
    return request(`api/project/${id}`).then((x) => x.json());
}
export function getProjectDashboardData(id: number): Promise<ProjectDashboardData> {
    return request(`api/project/${id}/dashboard`).then((x) => x.json());
}
export function getProjectUnits(id: number, req: PaginatedSearchRequest): Promise<PaginationResult<ProjectUnit>> {
    return request(`api/project/${id}/units`, { query: req }).then((x) => x.json());
}
export function getProjectUnitsExportUrl(id: number, req: PaginatedSearchRequest) {
    return `api/project/${id}/units/excel?${toQueryString(req)}`;
}

export function setModule(projectId: number, req: SetModuleRequest) {
    return request(`api/project/${projectId}/module`, {
        method: 'POST',
        body: req,
        json: true,
    });
}

export async function getAvailableDocumentCategories(projectId: number): Promise<AvailableDocumentCategoriesDto> {
    return await request(`api/project/${projectId}/availableDocumentCategories`, {
        method: 'GET',
        json: true,
    }).then((x) => x.json());
}

export async function setDocumentCategoryHierarchy(
    projectId: number,
    categoryHierarchyId: number
): Promise<AvailableDocumentCategoriesDto> {
    return await request(`api/project/${projectId}/documentCategoryHierarchy/${categoryHierarchyId}`, {
        method: 'POST',
        json: true,
    }).then((x) => x.json());
}

export function getLandingPageData(projectId: number): Promise<ProjectLandingPageData> {
    return request(`api/project/${projectId}/landing-page`).then((x) => x.json());
}

export function getConstructionPhases(projectId: number): Promise<ProjectConstructionPhase[]> {
    return request(`api/project/${projectId}/construction-phases`).then((x) => x.json());
}

export async function createSubProject(req: CreateSubProjectDto): Promise<void> {
    await request(`api/project/${req.parentProjectId}/create-sub-project`, {
        method: 'POST',
        body: req,
        json: true,
    });
}

export async function transfereFDVFromAmToCM(projectId: number): Promise<void> {
    await request(`api/project/${projectId}/transfer-fdv`, {
        method: 'POST',
        json: true,
    });
}
export type AvailableDocumentCategoriesDto = {
    selectedHierarchy?: number;
    categories: DocumentCategoriesDto[];
    hasLinkedDocuments: boolean;
};

export type DocumentCategoriesDto = {
    id: number;
    name: string;
};

export interface ProjectConstructionPhase {
    id: number;
    name: string;
}
export interface ResidentialUnitLinkInfo {
    residentialUnitId: number;
    residentialUnitName: string;
    //linkedGroups: LinkedCatalogGroup[];
    residentialUnitGroupId: number | null;
    residentialUnitGroupName: string;
    layoutType: string;
    floor: string;
    //tags: ProjectTag[];
}

export function getResidentialUnitLinkInfo(projectId: number): Promise<ResidentialUnitLinkInfo[]> {
    return request(`api/project/${projectId}/units-link-info`).then((x) => x.json());
}

export interface SetModuleRequest {
    module: BygrModule;
    isActive: boolean;
}

interface AdminLandingPageImageDTO extends LandingPageImageDTO {
    constructionPhaseId: number | null;
    userFileId: number | null;
}

export interface ProjectLandingPageData {
    cmImages: AdminLandingPageImageDTO[];
    amImages: AdminLandingPageImageDTO[];
}
